var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 53,
    viewBox: "0 0 46 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0625 45.9444L33.375 51.5L44 40.3889M22.75 1.5H10C7.02473 1.5 5.53708 1.5 4.40068 2.10553C3.40105 2.63814 2.58835 3.48803 2.07904 4.53339C1.5 5.72178 1.5 7.2775 1.5 10.3889V42.6111C1.5 45.7225 1.5 47.2783 2.07904 48.4667C2.58835 49.5119 3.40105 50.3619 4.40068 50.8944C5.53708 51.5 7.02473 51.5 10 51.5H18.7656M22.75 1.5L38.6875 18.1667M22.75 1.5V13.7222C22.75 15.2779 22.75 16.0558 23.0395 16.65C23.2943 17.1726 23.7004 17.5976 24.2003 17.8639C24.7685 18.1667 25.5122 18.1667 27 18.1667H38.6875M38.6875 18.1667V30.3889M12.125 40.3889H18.7656M12.125 29.2778H28.0625M12.125 18.1667H14.7812",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.9fe1e21dec2ffc284207bbe928a2b228.svg";
export { ForwardRef as ReactComponent };